import React from 'react';
import { useRecoilValue } from 'recoil';
import { cartState } from 'app-state/cart-state';
import formatPrice from 'utils/format-price';
import { Button } from './Button';

const CartContentsMessage = ({ button, includeTotal }: { button?: boolean, includeTotal?: boolean }) => {
  const { cartItemCount, cartTotal } = useRecoilValue(cartState);
  return <div className='p-4 text-2xl align-middle'>
    <span id='cart-contents-message'>
      <>You have <strong>{cartItemCount} item{cartItemCount != 1 ? 's' : ''}</strong></>
      <> in your cart{includeTotal && <>, totalling <strong>{formatPrice(cartTotal)}</strong></>}.</>
    </span>
    {button && <span className='pl-4'>
      <Button primary id='my-cart-button' linkTo='/cart'>My Cart<span className='text-lg'>&#8594;</span></Button>
    </span>}
  </div>;
};

export default CartContentsMessage;
